export const isNullUndefinedOrEmpty = (field, isArray = false) => {
    if (field === null || field === undefined || field === "") {
        return true
    } else {
        return isArray ? field.length === 0 : false
    }
}

export const getTrimmedValue = (value) => {
    return (value !== null & value !== undefined) ? value.trim() : "";
}